import apiClient from '../../../shared/services/apiHelper';
import { getUserData, getOuId } from '../../../shared/utils/authStorage';

export const dashboardService = {
  // Fetch dashboard counts
  fetchDashboardCounts: async () => {
    const orgId = getOuId();
    try {
      const response = await apiClient.get(`/dashboard/count?org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard counts:', error);
      throw error;
    }
  },

  // Fetch maintenance requests for dashboard
  fetchMaintenanceRequests: async (sort) => {
    const today = new Date();
    const to = today.toISOString().split('T')[0];
  
    const lastMonth = new Date();
    lastMonth.setDate(today.getDate() - 30);
    const from = lastMonth.toISOString().split('T')[0];
  
    try {
      const response = await apiClient.post(
        `/task/search?sort=${sort}`,
        {
          scheduled_date: {
            from: from,
            to: to,
          },
        }
      );
  
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance requests:', error);
      throw error;
    }
  },

  // Fetch equipment data for dashboard
  fetchEquipment: async (page = 1,) => {
    const user = getUserData();
    const ouId = user?.organization_unit.org_id;
    console.log(`ouid is ${ouId}`);
    try {
      const response = await apiClient.get('/equipment', {ouId:ouId });
      return response.data;
    } catch (error) {
      console.error('Error fetching equipment:', error);
      throw error;
    }
  }
};